/**
 * POM-6152 — one reversal-review allocation can straddle both buckets.
 *
 * A settlement (receiving tally, Manual Adjustment) proves part of a claim real and records it in
 * settledQty. The allocation still holds its whole quantity for the line item, so the reviewer
 * resolves all of it — but only `quantity - settledQty` is still system deficit; the rest is
 * ordinary confirmed stock. Core spends the open deficit FIRST on every resolution
 * (reversalReviewService), and restock items are sent before discard items, so the preview here
 * follows the same order or it would describe a different outcome than the one written.
 */
export const getClaimSplit = (row) => {
  const quantity = Number(row?.quantity) || 0;
  const settled = Math.min(quantity, Math.max(0, Number(row?.settledQty) || 0));
  const openClaim = row?.isUnverified ? quantity - settled : 0;
  return { quantity, openClaim, confirmed: quantity - openClaim };
};

/**
 * How much of each entered quantity comes off the open deficit and how much is confirmed stock.
 * Restock is spent first, matching the order handleSubmit sends the items in.
 */
export const previewResolution = ({ openClaim, restockQty, discardQty }) => {
  const restockFromClaim = Math.min(restockQty, openClaim);
  const discardFromClaim = Math.min(discardQty, openClaim - restockFromClaim);
  return {
    restockFromClaim,
    restockFromStock: restockQty - restockFromClaim,
    discardFromClaim,
    discardFromStock: discardQty - discardFromClaim,
  };
};
